import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {

    private supported = ['es', 'en'];

    constructor(private translate: TranslateService) { }

    init() {
        this.translate.addLangs(this.supported);
        this.translate.setFallbackLang('es');

        const stored = localStorage.getItem('lang');
        const browser = this.translate.getBrowserLang();

        let lang: string;

        if (stored && this.supported.includes(stored)) {
            lang = stored;
        } else if (browser && this.supported.includes(browser)) {
            lang = browser;
        } else {
            lang = 'es';
        }

        this.fnChangeLanguage(lang);
    }

    fnChangeLanguage(lang: string) {
        this.translate.use(lang);
        localStorage.setItem('lang', lang);
    }

    getCurrentLang(): string {
        return this.translate.getCurrentLang() || 'es';
    }
}